module.exports = __webpack_public_path__ + "static/media/how-to-be-an-antiracist.bf575f93.jpg";